interface ImageSizes {
  display: Blob;
  thumbnail: Blob;
}

export const generateImages = (file: File): Promise<ImageSizes> => {
  const generateImage = (maxWidth: number, maxHeight: number, quality: number): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        // Calculate dimensions while maintaining aspect ratio
        let width = img.width;
        let height = img.height;
        
        // Calculate scale factor
        let scale = 1;
        
        if (width > height) {
          if (width > maxWidth) {
            scale = maxWidth / width;
            width = maxWidth;
            height = Math.round(height * scale);
          }
        } else {
          if (height > maxHeight) {
            scale = maxHeight / height;
            height = maxHeight;
            width = Math.round(width * scale);
          }
        }

        // Create canvas and context
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          reject(new Error('Failed to get canvas context'));
          return;
        }

        // Enable image smoothing for better quality
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        // Draw image to canvas with proper scaling
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, height);

        // Convert canvas to blob with compression
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Failed to generate image'));
            }
          },
          'image/jpeg',
          quality
        );
      };

      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        reject(new Error('Failed to load image'));
      };
    });
  };

  return Promise.all([
    generateImage(2000, 2000, 0.82), // Display image: 2000x2000, 82% quality
    generateImage(300, 300, 0.75)    // Thumbnail: 300x300, 75% quality
  ]).then(([display, thumbnail]) => {
    return { display, thumbnail };
  });
}; 